import Cookies from 'js-cookie';
import { theFlats } from '../productDisplay/_swatchClick';
import { quickConvert } from '../international/_intl';

const setSelected = (that) => {
	$(that).prop('selected', true);
};

const selectFlatSize = ($sizeClicked) => {
	if (!$sizeClicked.hasClass('size-selected')) {
		$sizeClicked.addClass('size-selected');
		$.each($('.size-select-flat li'), function () {
			$(this).removeClass('flat-size-error');
		});
	}
	$sizeClicked.siblings().removeClass('size-selected');

	// Below is for displaying price of size selected above the add to bag(only for items with a price range)
	if ($sizeClicked.data('othersprice') && $('.swatch-list li img').hasClass('swatch-selected')) theFlats($sizeClicked, false);
	if ($sizeClicked.data('othersprice') && $('.color-select-group p').hasClass('one-option')) theFlats($sizeClicked, true);

	//Add the strike through
	$('.swatch-list li').prepend("<span class='swatch-disabled'></span>");

	var sizeClicked = $sizeClicked.attr('data-attrvalue');
	$('.color-select option:not(:contains(Color))').each(function () {
		
		var thisOption = $(this);
		var sizeAvForColor = $(this).attr('data-others');
		var sizesArray = sizeAvForColor.split('|');
		if (sizesArray.indexOf(sizeClicked) !== -1) {
			var colorMatch = thisOption.attr('data-attrvalue');
			$('.swatch-list li img').each(function () {
				if ($(this).attr('data-colorname') === colorMatch) {
					$(this).siblings().remove();
				}
			});
		}
	});

	if ($('.color-select-group p').hasClass('one-option')) {
		$('.swatch-list li img').siblings().remove();
	}

	var SizeSelected = $sizeClicked.hasClass('size-selected'),
		DisabledSize = $sizeClicked.hasClass('DisabledFlatSize');
	if ($sizeClicked.hasClass('size-selected')) setSelected(`.size-select option[value="${$sizeClicked.attr('value')}"]`);
	else {
		setSelected('.size-select option:eq(0)');
		$('.swatch-list li img').siblings().remove();
		$('.thisPrice').remove();
		$('#mainPrice .price-wrapper').show();
		$('.thisSalePrice').remove();
		$('.orgNowPrice').show();
	}
	if ($sizeClicked.hasClass('DisabledFlatSize')) setSelected('.size-select option:eq(0)');
	if (SizeSelected && !DisabledSize) {
		$sizeClicked.parents().parents('.size-select-group-flat').siblings('.size-select-group').removeClass('has-error');
		$('.size-select-group-flat .popover-error').remove();
	}

	if (SizeSelected && DisabledSize) {
		$sizeClicked.parents().parents('.size-select-group-flat').siblings('.size-select-group').addClass('has-error');
		$sizeClicked.tooltip('show');
		let tooltipID = $sizeClicked.attr('aria-describedby');
		setTimeout(function () {
			$(`#${tooltipID}`).remove();
		}, 2000);
	}
	return false;
};

export const theFlatsMobileQV = (that, oneOption) => {
	console.log({that, oneOption})
	var sizePrice = that.data('othersprice'),
		swatchColorSelected = $('.dynamicModalContainer .color-select option:selected').data('attrvalue'),
		yourPrice = '';
		oneOption = $('.color-select-group p').hasClass('one-option');
	
 		$(sizePrice.split('|')).each(function () {
			if ((this.split(':')[0] == swatchColorSelected) || oneOption ) {
				yourPrice = this.split(':')[1];
				yourPrice = quickConvert(yourPrice)
			}
		});

	let currency = $('.price-number').text(),
		currencyFinal = currency.substring(0, currency.search(/\d/)),
		priceVal = Cookies.get('zCountry') == 'US' ? yourPrice : quickConvert(yourPrice);
		priceVal = quickConvert(priceVal);
		let sizePriceContainer = $(`<span class='thisPrice'>${priceVal}</span>`);
		// ${Cookies.get('zCountry') === 'US' ? '$' : ''}
	$('.dynamicModalContainer .thisPrice').remove();

	//Below is for changing the price displayed
	if ($('.dynamicModalContainer .original-price').length > 0) {
		$(sizePriceContainer).insertBefore($('.quick-view-main-price .price-wrapper'));
		var origPrice = $('.dynamicModalContainer  .original-price .price-number').text().slice(1);
		var origPriceIndex = origPrice.lastIndexOf(currencyFinal);
		var origPriceFinal = quickConvert(origPrice.substring(origPriceIndex + 1));
		var yourPriceUSD = quickConvert(parseFloat(yourPrice).toFixed(2));
		var originalPriceUSD = quickConvert(parseFloat($('.original-price').children().last().attr('data-usd')).toFixed(2));

		if (Cookies.get('zCountry') !== 'US' && yourPriceUSD !== originalPriceUSD) {
			$('.dynamicModalContainer .thisPrice').remove();
			$('.thisSalePrice').remove();
			$('.quick-view-main-price .price-wrapper').show();
			$('.quick-view-main-price .now-price').addClass('orgNowPrice');
			$('.orgNowPrice').hide();
			$('.quick-view-main-price .price-wrapper').append(
				$(`<span class="thisSalePrice price now-price">Now<span class="price-number no-right-margin">${Cookies.get('zCountry') === 'US' && zonosIsWorking ? '$' : ''}${priceVal}</span></span>`)
			);
		} else {
			if (Cookies.get('zCountry') !== 'US') {
				$(sizePriceContainer).insertBefore($('.quick-view-main-price .price-wrapper'));
				$('.dynamicModalContainer .price-wrapper').hide();
			}
		}

		if (Cookies.get('zCountry') === 'US' && origPriceFinal !== priceVal) {
			$('.dynamicModalContainer .thisPrice').remove();
			$('.dynamicModalContainer .thisSalePrice').remove();
			$('.quick-view-main-price .price-wrapper').show();
			$('.quick-view-main-price .now-price').addClass('orgNowPrice');
			$('.orgNowPrice').hide();
			$('.quick-view-main-price .price-wrapper').append(
				$(`<span class="thisSalePrice price now-price">Now<span class="price-number no-right-margin">${Cookies.get('zCountry') === 'US' && zonosIsWorking ? '$' : ''}${priceVal}</span></span>`)
			);
		} else {
			if (Cookies.get('zCountry') === 'US') {
				$(sizePriceContainer).insertBefore($('.quick-view-main-price .price-wrapper'));
				$('.dynamicModalContainer .price-wrapper').hide();
			}
		}
		if (yourPrice == '') {
			$('.dynamicModalContainer .thisPrice').remove();
			$('.quick-view-main-price .price-wrapper').show();
			$('.dynamicModalContainer .orgNowPrice').show();
			$('.dynamicModalContainer .thisSalePrice').hide();
		}
		if ($('.dynamicModalContainer .size-selected').length === 0) {
			$('.dynamicModalContainer .price-wrapper').show();
			$('.dynamicModalContainer .thisPrice').remove();
		}
	} else {
		if (($('.dynamicModalContainer .one-option').length = 0)) {
			$(sizePriceContainer).insertBefore($('.quick-view-main-price'));
			$('.quick-view-main-price .price-number').hide();

			if ($('.dynamicModalContainer .size-selected').length === 0) {
				$('.dynamicModalContainer .price-wrapper').show();
				$('.dynamicModalContainer .thisPrice').remove();
			}
		}

		if (
			$('.dynamicModalContainer .original-price').length == 0 &&
			$('.dynamicModalContainer .now-price').length == 0 &&
			$('.dynamicModalContainer .quick-view-main-price').text().indexOf('-') !== -1
		) {
			if ($('.dynamicModalContainer .size-selected').hasClass('DisabledFlatSize')) {
				$('.dynamicModalContainer .thisPrice').remove();
				$('.dynamicModalContainer .quick-view-main-price').show();
			}
			if (!$('.dynamicModalContainer .size-selected').hasClass('DisabledFlatSize') && $('.dynamicModalContainer .size-selected').text().indexOf('-') == -1) {
				$(sizePriceContainer).insertBefore($('.quick-view-main-price'));
				$('.dynamicModalContainer .quick-view-main-price').hide();
			}
			if (
				$('.dynamicModalContainer .size-selected').length === 0 ||
				($('.dynamicModalContainer .size-selected').length > 0 && $('.dynamicModalContainer .color-select').val() == '')
			) {
				$('.dynamicModalContainer .quick-view-main-price').show();
				$('.dynamicModalContainer .thisPrice').remove();
			}
		}
	}

	//End of changing the price displayed
};

const selectFlatSizeQV = ($sizeClicked) => {
	if (!$sizeClicked.hasClass('size-selected')) {
		$sizeClicked.addClass('size-selected');
	}
	$sizeClicked.siblings().removeClass('size-selected');
	$sizeClicked.siblings().removeClass('flat-size-error');

	// Below is for displaying price of size selected above the add to bag(only for items with a price range)
	if ($('.dynamicModalContainer .one-option').length > 0) {
		if ($sizeClicked.data('othersprice') && $('.color-select-group p').hasClass('one-option')) theFlatsMobileQV($sizeClicked, true);
	} else {
		if ($sizeClicked.data('othersprice') && $('.dynamicModalContainer .color-select') !== '*') theFlatsMobileQV($sizeClicked, false);
	}

	//Add the strike through

	var sizeClicked = $sizeClicked.attr('data-attrvalue');
	var SizeSelected = $sizeClicked.hasClass('size-selected'),
		DisabledSize = $sizeClicked.hasClass('DisabledFlatSize');
	if ($sizeClicked.hasClass('size-selected')) setSelected(`.dynamicModalContainer .size-select option[value="${$sizeClicked.attr('value')}"]`);
	else {
		setSelected('.size-select option:eq(0)');
		$('.swatch-list li img').siblings().remove();
		$('.thisPrice').remove();
		$('#mainPrice .price-wrapper').show();
		$('.thisSalePrice').remove();
		$('.orgNowPrice').show();
	}
	if ($sizeClicked.hasClass('DisabledFlatSize')) setSelected('.dynamicModalContainer .size-select option:eq(0)');
	if (SizeSelected && !DisabledSize) $sizeClicked.parents().parents('.size-select-group-flat-qv').siblings('.size-select-group').removeClass('has-error');
	if (SizeSelected && DisabledSize) {
		$sizeClicked.parents().parents('.size-select-group-flat').siblings('.size-select-group').addClass('has-error');
		$sizeClicked.tooltip('show');
		let tooltipID = $sizeClicked.attr('aria-describedby');
		setTimeout(function () {
			$(`#${tooltipID}`).remove();
		}, 2000);
	}

	var qvSizeSelectedVal = $('.dynamicModalContainer .size-select').find(':selected').data('attrvalue');
	if (qvSizeSelectedVal != '*') {
		$('.size-select-group-flat-qv .popover-error').remove();
	}

	try {
	  if (typeof zonos === 'object') {
	    zonos.displayCurrency();
	  } else {
	    var zonosInterval = setInterval(function () {
	      if (typeof zonos === 'object') {
	        zonos.displayCurrency();
	        clearInterval(zonosInterval);
	      }
	    }, 250);

	    setTimeout(function () {
	      clearInterval(zonosInterval);
	    }, 5000);
	  }
	} catch (e) {
	  console.log(e);
	}
	
	return false;
};

export const flatSizeClickMobile = () => {
	if ($('.dynamicModalContainer').length == 0) {
		$('.size-select-flat').addClass('notQVFlatSize');
		var touchStartPos = 0;
		$('.notQVFlatSize li')
			.on('touchstart', function () {
				touchStartPos = $(window).scrollTop();
			})
			.on('touchend', function () {
				var distance = touchStartPos - $(window).scrollTop();
				if (!(distance > 20 || distance < -20)) {
					selectFlatSize($(this));
				}
			});
	}

	if ($('.dynamicModalContainer').length > 0) {
		var touchStartPosQV = 0;
		$('.dynamicModalContainer .size-select-group-flat-qv .size-select-flat > li')
			.on('touchstart', function () {
				touchStartPosQV = $('.dynamicModalContainer .modal-body .qv-intDiv').offset().top;
				if ($('#OrderItemAdd_qv .has-error').length < 1) {
					$('.dynamicModalContainer .popover-wrapper').remove();
				}
			})
			.on('touchend', function () {
				var subTouchEnd = $('.dynamicModalContainer .modal-body .qv-intDiv').offset().top;
				var distance = touchStartPosQV - subTouchEnd;
				if (!(distance > 20 || distance < -20)) {
					selectFlatSizeQV($(this));
				}
			});
	}
};
